import { Box, BoxProps } from '@mui/material';

export const Spinner = () => (
  <svg
    version="1.1"
    id="loader-1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    enableBackground="new 0 0 40 40"
    xmlSpace="preserve"
  >
    <path
      opacity="0.2"
      fill="#3137B2"
      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946
     s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634
     c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
    />
    <path
      fill="#3137B2"
      d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
     C22.32,8.481,24.301,9.057,26.013,10.047z"
    >
      <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite" />
    </path>
  </svg>
);

export const FullPageSpinner = ({ sx }: BoxProps) => (
  <Box
    sx={{
      height: '100vh',
      width: '100%',
      position: 'relative',
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      ...sx,
    }}
  >
    <Spinner />
  </Box>
);

export default Spinner;

export const SpinnerCircle = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="5em" height="5em" viewBox="0 0 24 24">
    <circle cx="4" cy="12" r="3" fill="currentColor">
      <animate
        id="svgSpinners3DotsBounce0"
        attributeName="cy"
        begin="0;svgSpinners3DotsBounce1.end+0.25s"
        calcMode="spline"
        dur="0.6s"
        keySplines=".33,.66,.66,1;.33,0,.66,.33"
        values="12;6;12"
      />
    </circle>
    <circle cx="12" cy="12" r="3" fill="currentColor">
      <animate
        attributeName="cy"
        begin="svgSpinners3DotsBounce0.begin+0.1s"
        calcMode="spline"
        dur="0.6s"
        keySplines=".33,.66,.66,1;.33,0,.66,.33"
        values="12;6;12"
      />
    </circle>
    <circle cx="20" cy="12" r="3" fill="currentColor">
      <animate
        id="svgSpinners3DotsBounce1"
        attributeName="cy"
        begin="svgSpinners3DotsBounce0.begin+0.2s"
        calcMode="spline"
        dur="0.6s"
        keySplines=".33,.66,.66,1;.33,0,.66,.33"
        values="12;6;12"
      />
    </circle>
  </svg>
);
